<template>
  <div>
    <div class="detail container1">
      <div class="banner">
        <div class="main">
          <div class="img_box" v-for="(v,i) in activeImg" :key="i">
            <img v-lazy="v">
          </div>
        </div>
        <div class="swiper_box">
          <Swiper ref="mySwiper" :options="swiperOption">
            <swiper-slide :class="{'swiper-slide':true,active:imgActiveI===i}" v-for="(v,i) in previewImgList" :key="i" @click.native="getActiveImg(i)">
              <img v-lazy="v.filePath">
              <div class="mask_img"></div>
            </swiper-slide>
          </Swiper>
          <div class="swiper-button-next" v-show="previewImgList.length>5">
            <i class="myicon iconfont icon-xiayiye"></i>
          </div>
          <div class="swiper-button-prev" v-show="previewImgList.length>5">
            <i class="myicon iconfont icon-xiayiye-copy"></i>
          </div>
        </div>
      </div>
      <h2 class="theme_title">{{themeInfo.name}}</h2>
      <p class="theme_sub_title">{{themeInfo.introduce}}</p>

      <div class="tab">
        <tab-detail ref="tabDetail" v-show="isDetail" @getThemeInfo="getThemeInfo"></tab-detail>
        <tab-match ref="tabMatch" v-show="!isDetail" :footerHeight="footerHeight"></tab-match>
      </div>

      <div :class="{scroll_menu:true,fixed:isFixed}">
        <el-button :class="{item:true,active:isDetail}" @click="onChangeDetail(true)">套 餐 详 情</el-button>
        <el-button :class="{item:true,active:!isDetail}" @click="onChangeDetail(false)">选 择 搭 配</el-button>
      </div>
    </div>
    <public-footer ref="pubFooter"></public-footer>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import TabDetail from "./detail";
import TabMatch from "./match";
import "swiper/dist/css/swiper.css";
export default {
  metaInfo: { title: "电器套餐 - 多比商城" },
  components: {
    Swiper,
    SwiperSlide,
    TabDetail,
    TabMatch,
  },
  data() {
    return {
      swiperOption: {
        direction: "vertical", //上下轮播
        spaceBetween: 15, //间隔距离
        autoplay: false,
        grabCursor: true,
        slidesPerView: 5,
        prevButton: ".swiper-button-prev",
        nextButton: ".swiper-button-next",
      },
      imgActiveI: 0,
      isDetail: true,
      isFixed: false,
      footerHeight: 0,
      themeInfo: {},
      previewImgList: [],
      activeImg: [],
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  updated() {
    this.footerHeight = this.$refs.pubFooter.$el.clientHeight;
    // console.log(11111, this.footerHeight);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    getThemeInfo(val) {
      this.themeInfo = val.themeInfo;
      this.previewImgList = val.previewImgList;
      this.getActiveImg(0);
    },
    // 右侧导航
    handleScroll() {
      // 页面被卷去的上高度
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // console.log(scrollTop);
      this.isFixed = scrollTop >= 800 ? true : false;
    },
    onChangeDetail(val) {
      if (this.isDetail === val) return;
      this.isDetail = val;
      let refName = this.isDetail ? "tabDetail" : "tabMatch";
      this.scrollInto(refName);
    },
    scrollInto(refName) {
      let element = this.$refs[refName].$el;
      // console.log(element);
      // 视图更新
      this.$nextTick(() => {
        // 不带对象参数兼容性好
        element.scrollIntoView();
      });
    },
    getActiveImg(val) {
      this.imgActiveI = val;
      if (this.previewImgList.length > 0) {
        this.activeImg[0] = this.previewImgList[this.imgActiveI].filePath || "";
      } else {
        this.activeImg[0] = "";
      }
    },
  },
};
</script>

<style lang="less" scoped>
@media (max-width: 1400px) {
  .scroll_menu {
    right: 0 !important;
  }
}
.detail {
  padding-bottom: 50px;
  color: #333333;
  line-height: 1;
  font-size: 14px;
  position: relative;
  .banner {
    margin-top: 34px;
    display: flex;
    height: 595px;
    .main {
      width: 954px;
      height: 100%;
      margin-right: 18px;
      .img_box {
        width: 100%;
        height: 100%;
      }
    }
    .swiper_box {
      width: calc(100% - 954px - 18px);
      height: 100%;
      position: relative;
      .swiper-container {
        height: 100%;
        width: 100%;
        box-sizing: border-box;
        padding-left: 32px;
        position: relative;
        z-index: 2;
        .swiper-wrapper {
          .swiper-slide {
            position: relative;
            &::before {
              display: none;
              content: "";
              width: 0;
              height: 0;
              position: absolute;
              left: -32px;
              top: 50%;
              margin-top: -8px;
              border-width: 8px 7px;
              border-style: solid;
              border-color: transparent @themeColor transparent transparent;
            }
            &::after {
              display: none;
              content: "";
              width: 0;
              height: 0;
              position: absolute;
              left: -30px;
              top: 50%;
              margin-top: -8px;
              border-width: 8px 7px;
              border-style: solid;
              border-color: transparent #ffffff transparent transparent;
            }
            &:hover {
              .mask_img {
                display: block;
              }
            }
          }
          .active {
            &::before,
            &::after {
              display: block;
            }
          }
        }
      }
      &::after {
        display: block;
        content: "";
        position: absolute;
        left: 14px;
        top: 0;
        width: 1px;
        height: 100%;
        background: @themeColor;
      }
      .swiper-button-next,
      .swiper-button-prev {
        top: auto;
        bottom: auto;
        left: 32px;
        right: auto;
        width: 186px;
        height: 22px;
        background-image: none;
        background: rgba(13, 24, 19, 0.2);
        color: #ffffff;
        z-index: 3;
        display: flex;
        justify-content: center;
        .myicon {
          font-size: 22px;
          width: 22px;
          height: 22px;
          display: block;
          transform: rotate(90deg);
          -ms-transform: rotate(90deg); /* IE 9 */
          -moz-transform: rotate(90deg); /* Firefox */
          -webkit-transform: rotate(90deg); /* Safari 和 Chrome */
          -o-transform: rotate(90deg); /* Opera */
        }
      }
      .swiper-button-prev {
        top: 22px;
      }
      .swiper-button-next {
        bottom: 0px;
      }
      .swiper-button-disabled {
        pointer-events: auto; //打开鼠标样式
        cursor: not-allowed;
      }
    }
  }
  .theme_title {
    margin-top: 34px;
    font-size: 26px;
    font-weight: bold;
  }
  .theme_sub_title {
    margin-top: 12px;
    font-weight: 500;
    color: #bfbfbf;
  }
  .scroll_menu {
    position: absolute;
    top: 765px;
    right: -90px;
    width: 38px;
    .el-button + .el-button {
      margin-left: 0px;
    }
    .item {
      font-size: 18px;
      line-height: 30px;
      padding: 0;
      width: 100%;
      height: 174px;
      border-radius: 0;
      white-space: normal;
      &:focus {
        color: @themeColor;
        border-color: @themeColor;
        background-color: #ffffff;
      }
    }
    .active {
      color: @themeColor;
      border-color: @themeColor;
    }
  }
  .fixed {
    position: fixed;
    top: 50%;
    right: calc((100% - 1190px) / 2 - 90px);
    margin-top: -174px;
  }
  .mask_img {
    cursor: pointer;
    width: 100%;
    height: 100%;
    background: #000000;
    opacity: 0.2;
    position: absolute;
    top: 0;
    left: 0;
    display: none;
  }
  .mask {
    position: relative;
    cursor: pointer;
    &::after {
      display: block;
      content: "";
      width: 100%;
      height: 100%;
      background: #000000;
      opacity: 0.2;
      position: absolute;
      top: 0;
      left: 0;
      display: none;
    }
    &:hover {
      &::after {
        display: block;
      }
    }
  }
}
</style>